export const exhaustiveSwitch = <T extends string | number | symbol, R>(
  value: T,
  cases: { [K in T]: () => R }
): R => {
  if (value in cases) {
    return cases[value]!();
  }

  // @ts-expect-error
  const _exhaustive: never = value;
  throw new Error(`Not all cases covered: ${_exhaustive}`);
};